module.exports = __webpack_public_path__ + "static/media/Maven_5910.b4355e90.jpg";